<script lang="ts">
	import { getCrossSaleFor, type CrossSaleProducts } from "./CrossSaleProducts";
	import type { ProductAmountPerCategory } from "../../../core/schema/ProductAmountPerCategory";
	import type { CartStore } from "../stores/cart/CartStore";
	import ProductCard from "./Product/ProductCard.svelte";
	import type { ProductForCustomer } from "../../../core/schema/Product";

	export let crossSaleProducts: CrossSaleProducts;
	export let forProduct: ProductForCustomer | undefined = undefined;
	export let loadedCartStore: CartStore;
	export let maxProductsPerCategory: ProductAmountPerCategory;

	$: slots = $loadedCartStore.loaded
		? getCrossSaleFor(
				crossSaleProducts,
				$loadedCartStore.value.productsInOrder.map(({ id }) => id),
				forProduct ? [forProduct] : $loadedCartStore.value.productsInOrder,
			)
		: [];
</script>

{#if slots.length > 0}
	<div class="my-24">
		<h2 class="decorative-headline text-center">Doporučujeme</h2>
		<p class="h2 mb-8 text-center !text-lg lg:!text-xl xl:!text-2xl">Vyberte si navíc</p>
		<div class="product-card-wrapper lg:mt-8">
			{#each slots as product, index (product.id)}
				<ProductCard {product} {index} {maxProductsPerCategory} asCrossSale={true} />
			{/each}
		</div>
	</div>
{/if}
